import { create } from 'zustand';
import { BaseFormProfile } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/types/profileTypes';

export type ProfileViewMode = 'list' | 'add' | 'edit';

interface ProfileSummaryState {
  viewMode: ProfileViewMode;
  editingProfileId: string;
  duplicateProfileData: BaseFormProfile | null;
  setViewMode: (mode: ProfileViewMode) => void;
  setEditingProfileId: (id: string) => void;
  setDuplicateProfileData: (data: BaseFormProfile | null) => void;
  reset: () => void;
}

export const useProfileSummaryStore = create<ProfileSummaryState>((set) => ({
  viewMode: 'list',
  editingProfileId: '',
  duplicateProfileData: null,
  setViewMode: (mode) => set({ viewMode: mode }),
  setEditingProfileId: (id) => set({ editingProfileId: id }),
  setDuplicateProfileData: (data) => set({ duplicateProfileData: data }),
  reset: () => set({ viewMode: 'list', editingProfileId: '', duplicateProfileData: null })
}));


